var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "https:_www.flaticon.com_free-icon_bench_2151537_term_fitness_20gym_page_3_position_42",
    "data-name": "https://www.flaticon.com/free-icon/bench_2151537#term=fitness%20gym&page=3&position=42",
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.801,
    height: 90.16,
    viewBox: "0 0 97.801 90.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M80.641,36.616a1.337,1.337,0,0,0,1.025.478h6.118a1.337,1.337,0,0,0,1.025-.478l2.566-3.056a1.337,1.337,0,0,0,.314-.862V24.676h4.777A1.337,1.337,0,0,0,97.8,23.338V18.753a1.337,1.337,0,0,0-1.337-1.337H91.688V9.393a1.337,1.337,0,0,0-.312-.86L88.81,5.478A1.337,1.337,0,0,0,87.784,5H81.666a1.337,1.337,0,0,0-1.025.478L78.076,8.534a1.337,1.337,0,0,0-.312.86v8.023H20.038V9.393a1.337,1.337,0,0,0-.313-.86L17.16,5.478A1.337,1.337,0,0,0,16.135,5H10.017a1.337,1.337,0,0,0-1.025.478L6.427,8.534a1.337,1.337,0,0,0-.314.865v8.023H1.337A1.337,1.337,0,0,0,0,18.753v4.584a1.337,1.337,0,0,0,1.337,1.337H6.113V32.7a1.337,1.337,0,0,0,.313.86l2.566,3.056a1.337,1.337,0,0,0,1.026.478h6.118a1.337,1.337,0,0,0,1.025-.478l.2-.244V85.078H4.393A4.4,4.4,0,0,0,0,89.475v4.346A1.337,1.337,0,0,0,1.337,95.16H96.464A1.337,1.337,0,0,0,97.8,93.823V89.478a4.4,4.4,0,0,0-4.393-4.393H80.437V36.373ZM95.127,20.093V22H91.688v-1.91ZM80.437,9.885,82.29,7.674h4.87l1.853,2.208V32.212L87.16,34.42H82.29l-1.853-2.208ZM77.762,20.093V22H20.038v-1.91ZM56.516,85.081V76.718h9.29a1.337,1.337,0,0,0,1.337-1.337V71.55a5.938,5.938,0,0,0-5.416-5.906V44.2a7.254,7.254,0,0,0-7.248-7.246H43.323A7.254,7.254,0,0,0,36.075,44.2V65.644a5.938,5.938,0,0,0-5.416,5.906v3.83A1.337,1.337,0,0,0,32,76.718h9.29v8.363H25.793v-60.4H72.008v60.4Zm2.536-19.463h-20.3V44.2a4.577,4.577,0,0,1,4.574-4.572H54.478A4.577,4.577,0,0,1,59.052,44.2ZM36.588,68.292H61.21a3.262,3.262,0,0,1,3.259,3.258v2.493H33.332V71.55a3.262,3.262,0,0,1,3.259-3.258Zm7.369,8.425h9.885v8.363H43.959ZM2.674,22v-1.91H6.113V22ZM15.511,34.417H10.641L8.787,32.212V9.885l1.854-2.211h4.869l1.853,2.208V32.212Zm4.527-9.742h3.08v60.4H20.038ZM95.126,89.468v3.018H2.674V89.478a1.721,1.721,0,0,1,1.719-1.719H93.407a1.721,1.721,0,0,1,1.719,1.716ZM74.682,85.074v-60.4h3.08v60.4Z",
    transform: "translate(0 -5)",
    fill: "#ff1414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M59.148,58.62h6.784a1.337,1.337,0,1,0,0-2.674H59.148a1.337,1.337,0,0,0,0,2.674Z",
    transform: "translate(-13.639 -17.02)",
    fill: "#ff1414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M66.962,64.225H57.2a1.337,1.337,0,0,0,0,2.674h9.766a1.337,1.337,0,0,0,0-2.674Z",
    transform: "translate(-13.179 -18.973)",
    fill: "#ff1414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M65.932,72.5H59.148a1.337,1.337,0,0,0,0,2.674h6.784a1.337,1.337,0,1,0,0-2.674Z",
    transform: "translate(-13.639 -20.925)",
    fill: "#ff1414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOne);
export default __webpack_public_path__ + "static/media/iconOne.92e37e419c1c4fe2c02635cb1c8b5eb0.svg";
export { ForwardRef as ReactComponent };